import {
  useGetWorkspaceFoldersQuery,
  useMoveDemoMutation,
} from '@carboncopyco/data';
import type { DemoOverlay, IDemo } from '@carboncopyco/types';
import { notify } from '@carboncopyco/ui';
import NiceModal, { useModal } from '@ebay/nice-modal-react';

import { MoveAssetModal } from '../../../MoveAssetModal';

type MoveDemoModalProps = {
  demo: IDemo | DemoOverlay;
  organizationId: string;
  workspaceId: string;
};

export const MoveDemoModal = NiceModal.create(
  ({ demo, organizationId, workspaceId }: MoveDemoModalProps) => {
    const modal = useModal();
    const [moveDemo, { isLoading }] = useMoveDemoMutation();
    const { data: folders } = useGetWorkspaceFoldersQuery({
      organizationId,
      workspaceId,
    });
    const demoFolderId = String(demo.folderId);

    return (
      <MoveAssetModal
        close={modal.remove}
        origin={{
          id: demoFolderId,
          workspaceId,
          entity: demoFolderId === '0' ? 'workspace' : 'folder',
        }}
        onSubmit={(targetFolderId) => {
          moveDemo({
            organizationId,
            targetFolderId: targetFolderId,
            id: Number(demo.id),
            currentFolderId: demoFolderId,
            workspaceId,
          })
            .unwrap()
            .then(() => {
              const folderName = folders.find(
                (folder) => String(folder.id) === targetFolderId
              )?.name;
              notify.success(
                `Demo successfully moved to ${targetFolderId === '0' ? 'workspace' : folderName}`
              );
            })
            .catch((error) => notify.error(error.data.message))
            .finally(modal.remove);
        }}
        blockOtherWorkspaces
        isLoading={isLoading}
        tooltipText="This asset cannot be moved between workspaces at the moment, but it will be supported soon!"
      />
    );
  }
);
